import React from 'react';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-center mb-8">Privacy Policy</h1>
      <p className="mb-4">
        This document describes how TALAY SANTTAI ("santtai.com", "us", "we" or
        "our") uses cookies on the website and how we handle and protect your
        personal data. By browsing and using our website you agree to this
        policy governing your use of the website. If you do not accept this
        policy, you should not use our website.
      </p>

      <h2 className="text-2xl font-semibold mb-4">
        1. What information does santtai.com collect?
      </h2>
      <p className="mb-4">
        1.1 We collect information from you when you sign up for promotional
        emails, contact customer support, or when you make a reservation.
      </p>
      <p className="mb-6">
        1.2 When making a reservation or registering on our site, as
        appropriate, you may be asked to enter your: name, gender, dive
        experience, email address, phone number, and special reservation
        requests, such as diet preferences and sizes of diving gear rentals.
      </p>

      <h2 className="text-2xl font-semibold mb-4">
        2. What does santtai.com use your information for?
      </h2>
      <p className="mb-4">
        2.1 The information you supply is needed to make the reservation on your
        behalf with the liveaboard operator. They need your basic information
        and in some cases passport information when the tours go cross border
        into multiple countries.
      </p>
      <p className="mb-6">
        2.2 The information you supply to our search system can also help us to
        recommend you better suited promotions and last minute deals. This we
        can better help you find the best liveaboard diving deal online.
      </p>

      <h2 className="text-2xl font-semibold mb-4">
        3. Does santtai.com use cookies?
      </h2>
      <p className="mb-4">
        3.1 Cookies are stored on your computer through your browser to help our
        system recognize you as a user. This way, for example, we can actually
        make the system remember what you searched, so we can display the
        results when you navigate through the website.
      </p>
      <p className="mb-4">
        3.2 We also use cookies to make the website work technically, understand
        and save your preferences for future visits, keep track of
        advertisements, and compile aggregate data about site traffic and site
        interactions so that we can offer better site experiences and tools in
        the future.
      </p>
      <p className="mb-6">
        3.3 We may contract with third-party service providers to assist us in
        better understanding our site visitors. These service providers are not
        permitted to use the information collected on our behalf except to help
        us conduct and improve our business.
      </p>

      <h2 className="text-2xl font-semibold mb-4">
        4. Is my information safe?
      </h2>
      <p className="mb-4">
        4.1 We offer the use of a secure server. All supplied sensitive/credit
        information is transmitted via Secure Socket Layer (SSL) technology and
        then encrypted into our Database to be only accessed by those authorized
        with special access rights to such systems, and are required to?keep the
        information confidential.
      </p>
      <p className="mb-6">
        4.2 After a transaction, your private information (credit cards, social
        security numbers, financials, etc.) will not be stored on our servers.
      </p>

      <h2 className="text-2xl font-semibold mb-4">
        5. Will santtai.com disclose any information to outside parties?
      </h2>
      <p className="mb-4">
        We do not sell, trade, or otherwise transfer to outside parties your
        personally identifiable information. This does not include trusted third
        parties who assist us in operating our website, conducting our business,
        or servicing you, so long as those parties agree to keep this
        information confidential. We may also release your information when we
        believe release is appropriate to comply with the law, enforce our site
        policies, or protect ours or others rights, property, or safety.
      </p>

      <h2 className="text-2xl font-semibold mb-4">6. Third party links</h2>
      <p className="mb-4">
        Occasionally, at our discretion, we may include or offer third party
        products or services on our website. These third party sites have
        separate and independent privacy policies. We therefore have no
        responsibility or liability for the content and activities of these
        linked sites. Nonetheless, we seek to protect the integrity of our site
        and welcome any feedback about these sites.
      </p>

      <h2 className="text-2xl font-semibold mb-4">
        7. Online Privacy Policy Only
      </h2>
      <p className="mb-4">
        This online privacy policy applies only to information collected through
        our website and not to information collected offline.
      </p>

      <h2 className="text-2xl font-semibold mb-4">8. Your Consent</h2>
      <p className="mb-4">
        By using our site, you consent to our website's privacy policy.
      </p>

      <h2 className="text-2xl font-semibold mb-4">
        9. Changes to our Privacy Policy
      </h2>
      <p className="mb-4">
        If we decide to change our privacy policy, we will post those changes on
        this page.
      </p>

      <h2 className="text-2xl font-semibold mb-4">10. Contacting Us</h2>
      <p className="mb-4">
        If there are any questions regarding this privacy policy you may contact
        us using the information below.
      </p>
      <p className="mb-4">[http://santtai.com](http://santtai.com)</p>
      <p>help@santtai.com</p>
    </div>
  );
};

export default PrivacyPolicy;
